import React from "react";
import SofaLogo from "../assets/sopa.webp";
import DVCLogo from "../assets/sopa.webp";
import QRCodeImage from "../assets/sopa.webp";
import SponsorLogo from "../assets/sopa.webp";

const CodeDesign = () => {
  return (
    <div className="w-80 h-[420px] bg-white border-4 border-orange-500 rounded-xl overflow-hidden shadow-lg font-sans relative">
      {/* Top Header */}
      <div className="flex justify-between items-center p-3 bg-orange-500">
        <img src={SofaLogo} alt="SOPA" className="h-8 w-auto" />
        <span className="text-white text-xs uppercase tracking-wide">
          Vision 2030
        </span>
      </div>

      {/* Body Content */}
      <div className="flex flex-col items-center text-center p-4 space-y-2">
        <h2 className="text-gray-600 text-xs uppercase">
          DVC Process Technologists presents
        </h2>
        <h1 className="text-2xl font-extrabold text-gray-800">
          International
          <br />
          Soy Conclave
        </h1>
        <p className="text-sm text-gray-600">13-16 October 2024</p>
        <p className="text-sm text-gray-600">
          Brilliant Convention Centre, Indore
        </p>

        <div className="w-32 h-32 mt-2">
          <img
            src={QRCodeImage}
            alt="QR Code"
            className="w-full h-full object-contain"
          />
        </div>

        <p className="text-lg font-bold text-gray-800">Anshul Jain</p>
        <p className="text-sm text-gray-500 uppercase">Delegate</p>
      </div>

      {/* Footer Sponsor */}
      <div className="absolute bottom-0 w-full bg-gray-100 p-3 flex flex-col items-center space-y-1">
        <p className="text-xs text-gray-600">Courtesy:</p>
        <img
          src={SponsorLogo}
          alt="Raja Agency"
          className="h-6 object-contain"
        />
        <p className="text-xs text-gray-600">Mobile: +91 91110 22821</p>
      </div>
    </div>
  );
};

export default CodeDesign;
